<template>
  <div>
    <router-view />
  </div>
</template>
<script>
import { useMyStorage } from "@/store/global";
import { ref, watch } from "vue";
import { ElLoading } from "element-plus";
export default {
  setup() {
    const store = useMyStorage();
    const techTimeout = ref(store.techTimeout);
    const loading = ref(
      ElLoading.service({
        lock: !techTimeout.value,
      //  text: "Ведутся технические работы на сервере",
      text: "Connecting ...",
        background: "rgba(255, 255, 255, 0.9)",
        customClass: "techtimeout",
      })
    );
    store.MyNatsSubscribe("test", (msg) => {
      console.log(msg);
    });
    watch(techTimeout, (newV) => {
      console.log(newV);
      if (newV === false) {
        loading.value.close();
      } else {
        loading.value = ElLoading.service({
          lock: !techTimeout.value,
          text: "Connecting ...",
          background: "rgba(255, 255, 255, 0.9)",
          customClass: "techtimeout",
        });
      }
    });
    const ls = localStorage.getItem("auth.langSelect");
    // console.log(ls)
    if (ls != null) {
      store.langSelect.value = ls * 1;
    }
    store.loadVersion();
    return {
      techTimeout,
    };
  },
};
</script>
<style lang="scss">
html,
body,
div#app {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
  background-color: white;
}
.row {
  display: flex;
  flex-direction: row;
}
@import url("https://fonts.googleapis.com/css2?family=Roboto&display=swap");
@font-face {
  font-family: Bahnschrift; /* Имя шрифта */
  src: url("~@/assets/fonts/BAHNSCHRIFT.TTF"); /* Путь к файлу со шрифтом */
}
@font-face {
  font-family: Proxima Nova Semibold; /* Имя шрифта */
  src: url("~@/assets/fonts/ProximaNova-Semibold.ttf"); /* Путь к файлу со шрифтом */
}
@font-face {
  font-family: Proxima Nova Light; /* Имя шрифта */
  src: url("~@/assets/fonts/ProximaNova-Light.ttf"); /* Путь к файлу со шрифтом */
}
@font-face {
  font-family: Proxima Nova Bold; /* Имя шрифта */
  src: url("~@/assets/fonts/ProximaNova-Bold.ttf"); /* Путь к файлу со шрифтом */
}
@font-face {
  font-family: Proxima Nova Regular; /* Имя шрифта */
  src: url("~@/assets/fonts/ProximaNova-Regular.ttf"); /* Путь к файлу со шрифтом */
}
@font-face {
  font-family: Proxima Nova Extrabold; /* Имя шрифта */
  src: url("~@/assets/fonts/ProximaNova-Extrabld.ttf"); /* Путь к файлу со шрифтом */
}
@font-face {
  font-family: Proxima Nova Condensed; /* Имя шрифта */
  src: url("~@/assets/fonts/ProximaNovaCond-Semibold.ttf"); /* Путь к файлу со шрифтом */
}
@font-face {
  font-family: Roboto Light; /* Имя шрифта */
  src: url("~@/assets/fonts/Roboto-Light.ttf"); /* Путь к файлу со шрифтом */
}
@font-face {
  font-family: Roboto Regular; /* Имя шрифта */
  src: url("~@/assets/fonts/Roboto-Regular.ttf"); /* Путь к файлу со шрифтом */
}
$primary: #1976d2;
$secondary: #26a69a;
$accent: #9c27b0;

$dark: #1d1d1d;

$positive: #21ba45;
$negative: #c10015;
$info: #31ccec;
$warning: #f2c037;

$l_primary: #00a76b;
$l_alert: #e82862;
$l_onsurface: #222222;
$l_surface: #fff;
$l_borders: #d4d9dd;
$l_onsurface_variant: #777;
$l_bg: #f7f7f7;
$l_bg_all: #333;
.el-dialog__body {
  word-break: normal !important;
}
.techtimeout .el-loading-text {
  color: #e82862 !important;
  font-family: Proxima Nova Condensed !important;
  font-style: normal !important;
  /* font-weight: 600;*/
  font-size: 24px !important;
  line-height: 24px !important;
}
</style>
